import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.paralax-section',
    },
    classNames: {
        inViewport: 'paralax-section--in-viewport'
    },
    dataAttributes: {
        smartedit: 'smartedit',
    },
    minPadding: 0,
    maxPadding: 130,
    translateTreshold: 0.2,
    maxTransitionDuration: 4,
    scrollDistanceTrigger: 1,
};

export class ParalaxSection {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isTransformed = false;
        this._prevPadding = 0;
        this.padding = 0;
    }

    static _canTransform = true;


    init() {
        this._elements = this._getDomElements();

        const child = document.querySelectorAll(config.selectors.root);
        for (const paralaxElement of child) {
            const children = $(paralaxElement.children);
            let myDivObjBgColor = children.css("background-color");

            if(children.hasClass('anchor-section')) {
                const subChildren = $(children.children());
                myDivObjBgColor = subChildren.css("background-color");
            }

            if($(children[0]).hasClass('edit-area')) {
                const subChildren =$(children[1]);
                myDivObjBgColor = subChildren.css("background-color");
            }
           
            const element = $(paralaxElement);
            element.css("background-color", myDivObjBgColor);
        }

        const smartedit = $('body').data(config.dataAttributes.smartedit);
        // edit-area

        if(smartedit !== true && smartedit !== 'true') {
            this._addEventListeners();
            
            const elementTop = this._$rootElement.offset().top;
            const elementBottom = elementTop + this._$rootElement.outerHeight();
            const elementMiddle = elementTop + (elementBottom - elementTop) / 2;
            const elementHeight = elementBottom - elementTop;
        
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();
            const viewportMiddle = viewportTop + (viewportBottom - viewportTop) / 2;

            const difference = elementMiddle - viewportMiddle;

            const factor = (difference / (elementHeight / 2)) / 2;

            // initialization rules
            if(factor > 1) {
                // elements below viewport
                this._$rootElement.css('opacity',  '0');
                this._$rootElement.css('padding-top', config.maxPadding);
            } else if(factor < -1) {
                // elements above viewport
                this._$rootElement.css('opacity',  '1');
                this._$rootElement.css('padding-top', 0);
            } else {
                // elements in viewport
                this._$rootElement.css('opacity',  '1');
                this._$rootElement.css('padding-top', 0);
            }
        }

    }

    _getDomElements() {
        return {

        }
    }

    _addEventListeners() {
        let prevViewportTop = $(window).scrollTop();
        let prevTimeStamp = new Date().getTime();
        
        $(window).on('scroll', (e) => {
            if (!ParalaxSection._canTransform) return;

            const timeStamp = new Date().getTime();
            const viewportTop = $(window).scrollTop();
            const difference = viewportTop - prevViewportTop;
            const positiveDifference = Math.sqrt(difference * difference);
            const scrollingDown = difference > 0;

            if (positiveDifference > config.scrollDistanceTrigger) {
                prevViewportTop = viewportTop;
                prevTimeStamp = timeStamp;
                this._adjustPadding(scrollingDown);
            }
        });
    }

    static setCanTransform(bool) {
        ParalaxSection._canTransform = bool;
    }

    _adjustPadding(scrollingDown) {
        const elementTop = this._$rootElement.offset().top;
        const elementBottom = elementTop + this._$rootElement.outerHeight();
        const elementMiddle = elementTop + (elementBottom - elementTop) / 2;
        const elementHeight = elementBottom - elementTop;

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        const viewportMiddle = viewportTop + (viewportBottom - viewportTop) / 2;

        const difference = elementMiddle - viewportBottom;

        // do nothing when element is not in viewport
        // if(Math.sqrt(difference * difference) > viewportBottom - viewportTop) return;

        // number indicating element position
        // x > 1: viewport above element
        // x = 1: element top at viewport bottom   
        // x = 0: viewport middle === element middle 
        // x = -1: element bottom at viewport top
        // x < -1: below element
        const factor = (difference / (elementHeight / 2));

        // handle opacity independant
        if(factor > 1) {
            this._$rootElement.css('opacity',  '0');
        } else if(factor < -1) {
            this._$rootElement.css('opacity',  '1');
        } else {
            this._$rootElement.css('opacity',  '1');
            this._$rootElement.css('transition', `opacity 0.2s ease-in, padding ${this._calcTransitionDuration(0)}s ease`);
        }


        // 0.5 means element top or bottom is at viewport middle
        if( 1 > factor && factor > 0.5 && scrollingDown) {
            // coming from top
            // console.log('coming from top - shrink');
            const newFactor = (factor - 0.5) * 2;

            const padding = config.minPadding + config.maxPadding - (1 - newFactor) * (config.maxPadding);

            // console.log('calculated padding', padding);


            if(this.padding !== 0 && padding > this.padding) return;

            
            this._$rootElement.css('transition', `opacity 0.2s ease-in, padding ${this._calcTransitionDuration(padding)}s ease`);
            this._$rootElement.css('padding-top', padding);
            this.padding = padding;

            return;
        }

        if(!scrollingDown && 1 < factor && this.padding !== this.maxPadding) {
            this._$rootElement.css('padding-top', config.maxPadding);
            this.padding = config.maxPadding;
        }
    }

    _calcTransitionDuration(padding) {
        const difference = this._prevPadding - padding;
        const factor = difference / config.maxPadding;
        const positiveFactor = Math.sqrt(factor * factor);

        return positiveFactor * config.maxTransitionDuration;
    }
}

moduleRegistry.registerModule('ParalaxSection', ParalaxSection);
moduleRegistry.autoApplyModule('ParalaxSection', config.selectors.root);
